// Everything a signed-in person leaves in this browser, wiped in one place. Tickets carry QR codes, so the
// order and checkout data kept in sessionStorage must not survive a logout for the next person on the tab.
const LOCAL_KEYS = ['accessToken', 'refreshToken', 'user'];
const SESSION_PREFIXES = ['order:', 'checkout:', 'pendingSignup'];

export function clearBrowserSession() {
  try {
    LOCAL_KEYS.forEach((k) => localStorage.removeItem(k));
    Object.keys(sessionStorage)
      .filter((k) => SESSION_PREFIXES.some((p) => k.startsWith(p)))
      .forEach((k) => sessionStorage.removeItem(k));
  } catch {
    // storage blocked: nothing to clear
  }
}
